import React, { useState, useRef, useEffect } from 'react';
import { ClearOutlined } from '@ant-design/icons';
import { Modal, notification } from 'antd';
import EventsModal from '../EventLog/EventsModal';
import { getCurrLeadId } from '../../amo/leads';
import { clearChecklist } from '../../services/checklistService';
import styles from './ChecklistContextMenu.module.css';

const ChecklistContextMenu = ({ checklist, children }) => {
    const [isClearing, setIsClearing] = useState(false);
    const [contextMenuVisible, setContextMenuVisible] = useState(false);
    const [contextMenuPosition, setContextMenuPosition] = useState({ x: 0, y: 0 });
    const containerRef = useRef(null);
    const [eventsVisible, setEventsVisible] = useState(false);

    
    const handleContextMenu = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        setContextMenuPosition({ x: e.clientX, y: e.clientY });
        setContextMenuVisible(true);
    };

    
    useEffect(() => {
        const handleClickOutside = () => {
            setContextMenuVisible(false);
        };

        if (contextMenuVisible) {
            document.addEventListener('click', handleClickOutside);
            return () => document.removeEventListener('click', handleClickOutside);
        }
    }, [contextMenuVisible]);

    
    const handleClearChecklist = async () => {
        Modal.confirm({
            title: 'Очистить чеклист',
            content: `Вы уверены, что хотите очистить все значения в чеклисте "${checklist.name}"? Это действие нельзя отменить.`,
            okText: 'Очистить',
            cancelText: 'Отмена',
            okType: 'danger',
            onOk: async () => {
                setIsClearing(true);
                setContextMenuVisible(false);
                
                try {
                    await clearChecklist(checklist.id);
                    notification.success({
                        message: 'Успешно',
                        description: `Чеклист "${checklist.name}" очищен`,
                        placement: 'topRight'
                    });
                } catch (error) {
                    notification.error({
                        message: 'Ошибка',
                        description: `Не удалось очистить чеклист: ${error.message}`,
                        placement: 'topRight'
                    });
                } finally {
                    setIsClearing(false);
                }
            }
        });
    };

    const handleShowEvents = () => {
        setContextMenuVisible(false);
        setEventsVisible(true);
    };



    return (
        <div 
            ref={containerRef}
            className={styles.container}
            onContextMenu={handleContextMenu}
        >
            {children}

            {/* Контекстное меню при клике правой кнопкой */}
            {contextMenuVisible && (
                <div 
                    className={styles.contextMenu}
                    style={{
                        position: 'fixed',
                        left: contextMenuPosition.x,
                        top: contextMenuPosition.y,
                        zIndex: 1000
                    }}
                    onClick={e => e.stopPropagation()}
                >
                    <div 
                        className={styles.contextMenuItem}
                        onClick={handleShowEvents}
                    >
                        Показать события
                    </div>
                    <div 
                        className={styles.contextMenuItem}
                        onClick={handleClearChecklist}
                    >
                        <ClearOutlined className={styles.contextMenuIcon} />
                        Очистить чеклист
                    </div>
                </div>
            )}

            {eventsVisible && (
                <EventsModal 
                    open={eventsVisible}
                    onClose={() => setEventsVisible(false)}
                    leadId={getCurrLeadId()}
                />
            )}
        </div>
    );
};

export default ChecklistContextMenu; 